'use es6';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { BaseResponsiveSectionToolbar, buildActionsForSection } from './BaseResponsiveSectionToolbar';
import { getIsInDeveloperMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileSectionToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  shouldUseCustomSections,
  isCommentable
}) => {
  const isPatagoniaSidebarCollapsed = useSelector(getIsPatagoniaSidebarCollapsed);
  const shouldClosePatagoniaSidebar = !isPatagoniaSidebarCollapsed;
  return /*#__PURE__*/_jsx(BaseResponsiveSectionToolbar, {
    active: false,
    actions: buildActionsForSection({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      shouldUseCustomSections,
      shouldClosePatagoniaSidebar,
      isCommentable
    }),
    responsiveSize: responsiveSize,
    showHandleGrippie: false,
    isSectionDropdownStep: false,
    isCommentable: isCommentable,
    isStaticSection: false
  });
};
MockResponsiveMobileSectionToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  shouldUseCustomSections: PropTypes.bool,
  isCommentable: PropTypes.bool
};
const MockResponsiveDesktopSectionToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  shouldUseCustomSections,
  isCommentable
}) => {
  const isInDeveloperMode = useSelector(getIsInDeveloperMode);
  return /*#__PURE__*/_jsx(BaseResponsiveSectionToolbar, {
    active: false,
    actions: buildActionsForSection({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      shouldUseCustomSections,
      isInDeveloperMode,
      isCommentable
    }),
    responsiveSize: responsiveSize,
    showHandleGrippie: false,
    isSectionDropdownStep: false,
    isCommentable: isCommentable,
    isStaticSection: false
  });
};
MockResponsiveDesktopSectionToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  shouldUseCustomSections: PropTypes.bool.isRequired,
  isCommentable: PropTypes.bool
};
export { MockResponsiveMobileSectionToolbarToMeasure, MockResponsiveDesktopSectionToolbarToMeasure };